import { currentTenantSlug, tenantUrl } from '@services/auth/tenant-routing';
import { Routes, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { NotFoundPageComponent } from './framework/components/not-found/not-found-page.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { NoAccessComponent } from './framework/pages/no-access/no-access.component';

const tenantRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  { path: 'login', component: LoginComponent, title: 'Active F - Sign in' },
  { path: 'logout', component: LoginComponent, data: { signOut: true } },
  { path: 'app', canActivate: [AuthGuard.canLoadApp], loadChildren: () => import('./framework/framework.routes').then((m): typeof m.routes => m.routes) },
  { path: 'no-access', component: NoAccessComponent, canActivate: [AuthGuard.noAccessGuard] },
  { path: '**', component: NotFoundPageComponent, title: 'Active F - Page Not Found' }
];

const routes: Routes = [
  // Root is the shared Cognito callback. Bootstrap restores the originating tenant before routing.
  { path: '', pathMatch: 'full', redirectTo: (): string => currentTenantSlug() ? inject(AuthService).consumeReturnUrl() : '/login' },
  { path: 'login', component: LoginComponent, title: 'Active F - Tenant link required' },
  { path: 'logout', component: LoginComponent, data: { signOut: true } },
  // Preserve the registered HMRC callback, whose redirect_uri must match the token exchange.
  { path: 'app/treasury/hmrc-auth', loadComponent: () => import('./modules/treasury/areas/banking/transactions/hmrc-auth/hmrc-auth.component').then((m): typeof m.HmrcAuthComponent => m.HmrcAuthComponent), canActivate: [AuthGuard.canLoadApp] },
  { path: 'app', pathMatch: 'prefix', redirectTo: (): string => currentTenantSlug() ? tenantUrl(inject(Router).getCurrentNavigation()?.initialUrl.toString() ?? '/app') : '/login' },
  { path: ':tenantSlug', canActivateChild: [AuthGuard.tenantRouteGuard], children: tenantRoutes },
  { path: '**', component: NotFoundPageComponent }
];

export default routes;
